export default "__VITE_ASSET__Dk4LrD5z__"